export * from './dialog-confirmation.component';
